export interface Plans {
  id: number;
  value: string;
  period: string;
  in_cents: number;
  discount: number;
  discount_value: number;
  plan_name: string;
  months: number;
  upgrade?: boolean;
  upgrade_value?: string | number;
  value_voucher?: string;
  code_share?: boolean;
  plan_type_name?: string;
  credits?: number | null;
}
interface iPermissions {
  active: boolean;
  name: string;
}
interface PlansType {
  plan_type_name?: string;
  plan_type_id?: number;
  permissions?: iPermissions[];
  plans?: Plans[];
  voucher?: string;
  cupomDesconto?: string;
}
export const planStore = defineStore("plans", {
  state: () => ({
    plans: [] as Array<Plans>,
    plansType: [] as Array<PlansType>,
    languagePlans: "" as string,
    coupon: "" as string | string[],
    voucher: "" as string | string[],
    closeBannerPlanUnique: false as boolean,
    cardOnlyPromotion: false as boolean,
    parcelamentoDisponivel: 1 as number,
    saldoUpgrade: "0,00" as string,
    cupomDesconto: "" as string,
    cupomDescontoPercent: 0 as number,
    dailyDownloadLimit: "5" as string
  }),
  getters: {
    effectiveDownloadLimit(state): string {
      const n = Number(state.dailyDownloadLimit);
      return Number.isFinite(n) && n > 0 ? String(n) : "5";
    },
  },
  actions: {
    async setSaldoUpgrade(payload: string) {
      this.saldoUpgrade = payload;
    },
    async setPlans(payload: Array<Plans>) {
      this.plans = payload;
      this.setLanguagePlans();
    },
    async setPlansType(payload: Array<PlansType>) {
      this.plansType = payload;
         this.setLanguagePlans();
    },
    async setCupomDesconto(payload: string) {
      this.cupomDesconto = payload;
      this.coupon = "";
      this.voucher = "";
      this.cupomDescontoPercent = 0;
    },
    async setCupomDescontoPercent(payload: number) {
      this.cupomDescontoPercent = Number(payload) || 0;
    },
    async setLanguagePlans() {
      const store = localeStore();
      this.languagePlans = store.locale;
    },
    async setCoupon(payload: string | string[]) {
      this.coupon = payload;
    },
    async setVoucher(payload: string | string[]) {
      this.voucher = payload;
    },
    async setCloseBanner(payload: boolean) {
      this.closeBannerPlanUnique = payload;
    },
    async setCardOnlyPromotion(payload: boolean) {
      this.cardOnlyPromotion = payload;
    },
    async setDownloadLimit(payload: string) {
      this.dailyDownloadLimit = payload;
    },
    async setParcelamentoDisponivel(payload: number) {
      this.parcelamentoDisponivel = payload;
    },
  },
  persist: {
    key: "plans",
    storage: piniaPluginPersistedstate.sessionStorage(),
    // Só persistimos a memória de cupom/voucher (motivo de existir a persistência:
    // visitante que voltou ao /assine sem o ?coupon na URL). Os campos de PREÇO
    // (plansType/plans/saldoUpgrade/...) ficam FORA da persistência: eles agora
    // vêm sempre do SSR (payload do Nuxt) ou de um novo fetch, então um
    // sessionStorage obsoleto não pode sobrescrever o estado do SSR e causar
    // hydration mismatch no primeiro render do cliente.
    pick: [
      "coupon",
      "voucher",
      "cupomDesconto",
      "cupomDescontoPercent",
      "closeBannerPlanUnique",
      "languagePlans",
    ],
  },
});
